export default __webpack_public_path__ + "static/media/UNAMID_womens_meeting.a26e2f3b.jpg";